'use client';

var initialBarChart = {
    tooltip: {
        x: 0,
        y: 0
    }
};

export { initialBarChart };
//# sourceMappingURL=index.js.map
